var map = {
	"./banner-20230701.jpg": "e44d",
	"./banner-20230901.jpg": "a4b5",
	"./banner-backup.jpg": "a768",
	"./banner-home-20230701.jpg": "6a77",
	"./banner-home-20230901.jpg": "440a",
	"./banner-home-backup.jpg": "b853",
	"./banner-home.jpg": "7b56",
	"./banner.jpg": "d156",
	"./sample-electric.jpg": "65d9",
	"./uploaddemo.jpg": "8461"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d1e";